'use client';

import { ContentfulLivePreview } from '@contentful/live-preview';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { GoogleAnalytics } from '@next/third-parties/google';
import { useEffect, useState } from 'react';
import { getCookieConsentValue } from 'react-cookie-consent';
import CookieBanner, { CONSENT_COOKIE_NAME } from '@/components/CookieBanner';
import {
	loadMicrosoftClarity,
	revokeClarityConsent,
	syncClarityConsentFromChoice,
} from '@/lib/microsoft-clarity';

const ANALYTICS_DEFER_MS = 5000;
const GTM_TAG = process.env.NEXT_PUBLIC_GTM_TAG;

export default function Globals() {
	const [analyticsReady, setAnalyticsReady] = useState(false);

	useEffect(() => {
		ContentfulLivePreview.init({ locale: 'en-US' });
	}, []);

	useEffect(() => {
		const timer = setTimeout(() => setAnalyticsReady(true), ANALYTICS_DEFER_MS);
		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		if (!analyticsReady) return;
		loadMicrosoftClarity();
		const stored = getCookieConsentValue(CONSENT_COOKIE_NAME);
		syncClarityConsentFromChoice(stored === 'true');
	}, [analyticsReady]);

	const enableAnalytics = () => setAnalyticsReady(true);

	return (
		<>
			<CookieBanner
				onAccept={enableAnalytics}
				onDecline={() => {
					if (analyticsReady) revokeClarityConsent();
				}}
			/>

			{analyticsReady && GTM_TAG ? <GoogleAnalytics gaId={GTM_TAG} /> : null}
		</>
	);
}
